import React from 'react';

import { splitBy } from 'utils/js';

export const isElementAnyTag =
  (...tags: string[]) =>
  (item: React.ReactElement): boolean => {
    if (!item.props) {
      throw new Error(`Found Invalid MDX node: ${JSON.stringify(item)}`);
    }

    return tags.includes(item.props.originalType);
  };

export const isElementTag =
  (tag: string) =>
  (item: React.ReactElement): boolean => {
    if (!item.props) {
      throw new Error(`Found Invalid MDX node: ${JSON.stringify(item)}`);
    }

    return item.props.originalType === tag;
  };

export const identity = (children: React.ReactNodeArray): { children: React.ReactNode } => ({ children });

export const splitHeadingsIntoGroups = (children: React.ReactNodeArray) => {
  const childrenArray = React.Children.toArray(children) as JSX.Element[];
  const groupedByTitles = splitBy(childrenArray, isElementTag('h1'));

  const content = groupedByTitles.map(([categoryTitle, ...items]) => ({
    slug: categoryTitle.props.id,
    title: categoryTitle,
    items: splitBy(items, isElementTag('h2')).map(([title, ...body]) => ({
      slug: title.props.id,
      title,
      body,
    })),
  }));

  return { content };
};

export const groupHeadingsToAdjacentContent =
  (...tags: string[]) =>
  (children: React.ReactNodeArray): { children: JSX.Element[] } => {
    const childList = Array.isArray(children) ? children : [children];
    const groups = splitBy(childList, isElementAnyTag(...tags));

    return {
      children: groups.map((group, index) => {
        const title = group[0] as React.ReactElement;
        return (
          <div key={title.props.id || index} id={title.props.id}>
            {group}
          </div>
        );
      }),
    };
  };
